import styled from 'styled-components';

import { Colors } from 'modules/ui/theme/colors';
import { H1 } from 'modules/ui/typography';

export const FormContainer = styled.div`
  width: 320px;
  background-color: ${Colors.White};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .field-container {
    margin-bottom: 16px;
    span {
      font-size: 12px;
      line-height: 18px;
      font-weight: 500;
    }
  }
`;

export const LogoImage = styled.img`
  width: 105px;
  margin-bottom: 60px;
`;

export const Title = styled(H1)`
  font-weight: bold;
  margin-bottom: 16px;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
`;
